module.exports = __webpack_public_path__ + "src/assets/images/icon-contractor.svg?cc359e9dd9b96d00494d767dad2753b1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-contractor.svg
// module id = 1001
// module chunks = 1